var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVisaLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 12,
    viewBox: "0 0 33 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33406 11.1443H5.58774L3.52833 3.05649C3.43058 2.68445 3.22304 2.35554 2.91774 2.20053C2.15584 1.81096 1.31628 1.50093 0.400391 1.34456V1.03318H4.8245C5.43509 1.03318 5.89303 1.50093 5.96936 2.04416L7.03789 7.87818L9.78287 1.03318H12.4529L8.33406 11.1443ZM13.9794 11.1443H11.3857L13.5214 1.03318H16.1151L13.9794 11.1443ZM19.4707 3.83427C19.547 3.28969 20.0049 2.97831 20.5392 2.97831C21.3788 2.90013 22.2933 3.05649 23.0565 3.44471L23.5145 1.26773C22.7512 0.956353 21.9117 0.799988 21.1498 0.799988C18.6324 0.799988 16.8007 2.20053 16.8007 4.14431C16.8007 5.62303 18.0982 6.39946 19.0141 6.86721C20.0049 7.33361 20.3865 7.64499 20.3102 8.11139C20.3102 8.81099 19.547 9.12237 18.7851 9.12237C17.8692 9.12237 16.9533 8.88917 16.1151 8.4996L15.6571 10.6779C16.573 11.0661 17.5639 11.2225 18.4798 11.2225C21.3024 11.2993 23.0565 9.90015 23.0565 7.80001C23.0565 5.15528 19.4707 5.00027 19.4707 3.83427ZM32.1337 11.1443L30.0743 1.03318H27.8623C27.4043 1.03318 26.9464 1.34456 26.7937 1.81096L22.9802 11.1443H25.6502L26.1831 9.66694H29.4637L29.769 11.1443H32.1337ZM28.2439 3.7561L29.0058 7.56682H26.8701L28.2439 3.7561Z",
    fill: "#172B85"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVisaLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/visa-logo.07aaf575232cb2a882229354a852b322.svg";